import React, { useMemo, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import './styleDeposit.css';
import * as XLSX from "xlsx";

export const IndexPatientCredit = ({
  close,
  companyInfo = [],
  formatter,
  navigateNim,
  valid_view,
  cancellPatient,
  countPatient,
  exportToExcelCancell,
  handleClosedView,
  ...props
}) => {

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [globalFilter, setGlobalFilter] = useState("");


  const companyData = useMemo(() => {

    if (!Array.isArray(companyInfo)) {
      return [];
    }

    return companyInfo.map((company) => {

      const patients = Array.isArray(company?.patientDetails)
        ? company.patientDetails
        : [];

      const validPatients = patients.filter(
        patient => patient?.status_oreder === "Vigente"
      );

      const totalCredit = validPatients.reduce(
        (total, patient) => total + Number(patient?.amount || 0),
        0
      );

      return {
        ...company,
        totalCredit,
        totalPatients: validPatients.length,
        patientDetails: patients
      };
    });

  }, [companyInfo]);


  const totalCompanies = companyData.length;


  const totalCredit = companyData.reduce(
    (total, company) => total + Number(company?.totalCredit || 0),
    0
  );


  const totalPatients = companyData.reduce(
    (total, company) => total + Number(company?.totalPatients || 0),
    0
  );


  const companyHighestCredit = useMemo(() => {

    if (companyData.length === 0) {
      return null;
    }

    return [...companyData].sort(
      (a, b) => b.totalCredit - a.totalCredit
    )[0];

  }, [companyData]);

  // * 
  const selectedPatients = useMemo(() => {

    if (!selectedCompany?.patientDetails) {
      return [];
    }

    return selectedCompany.patientDetails.filter(
      patient => patient?.status_oreder === "Vigente"
    );

  }, [selectedCompany]);


  const selectedCompanyTotal = selectedPatients.reduce(
    (total, patient) => total + Number(patient?.amount || 0),
    0
  );



  const topCompanies = useMemo(() => {

    return [...companyData]
      .filter(company => company.totalCredit > 0)
      .sort((a, b) => b.totalCredit - a.totalCredit)
      .slice(0, 5);

  }, [companyData]);


  const optionsCompanyChart = {

    chart: {
      type: "areaspline",
      backgroundColor: "transparent",
      height: 315,

      spacingTop: 15,
      spacingRight: 15,
      spacingBottom: 10,
      spacingLeft: 10
    },

    title: {
      text: null
    },

    credits: {
      enabled: false
    },

    exporting: {
      enabled: false
    },

    legend: {
      enabled: false
    },


    xAxis: {

      categories: topCompanies.map(
        company => company.nameCompany
      ),

      title: {
        text: null
      },

      lineColor: "#e2e8f0",

      tickColor: "#e2e8f0",

      tickLength: 0,

      labels: {

        rotation: 0,

        style: {
          fontSize: "9px",
          color: "#64748b",
          fontWeight: "500"
        },

        formatter: function () {

          const name = this.value || "";

          return name.length > 15
            ? `${name.substring(0, 15)}...`
            : name;
        }
      }
    },



    yAxis: {

      min: 0,

      title: {
        text: null
      },

      gridLineColor: "#edf2f7",

      gridLineDashStyle: "Dash",

      labels: {

        formatter: function () {

          return new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(this.value);
        },

        style: {
          fontSize: "9px",
          color: "#94a3b8"
        }
      }
    },



    tooltip: {

      useHTML: true,

      backgroundColor: "#ffffff",

      borderColor: "#e2e8f0",

      borderRadius: 8,

      shadow: true,

      formatter: function () {

        const value = new Intl.NumberFormat("es-MX", {
          style: "currency",
          currency: "MXN",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(this.y);

        return `
        <div style="
          padding: 5px 7px;
          min-width: 130px;
        ">

          <div style="
            font-size: 11px;
            font-weight: 700;
            color: #334155;
            margin-bottom: 5px;
          ">
            ${this.x}
          </div>

          <div style="
            font-size: 10px;
            color: #64748b;
          ">
            Crédito:

            <strong style="
              color: #287ea8;
              margin-left: 5px;
            ">
              ${value}
            </strong>

          </div>

        </div>
      `;
      }
    },


    plotOptions: {

      areaspline: {

        lineWidth: 3,

        marker: {
          enabled: true,

          radius: 4,

          lineWidth: 2,

          lineColor: "#ffffff",

          fillColor: "#175b78",

          states: {
            hover: {
              enabled: true,
              radius: 6
            }
          }
        },

        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1
          },

          stops: [
            [
              0,
              Highcharts.color("#2a6077")
                .setOpacity(0.25)
                .get("rgba")
            ],
            [
              1,
              Highcharts.color("#29596d")
                .setOpacity(0.01)
                .get("rgba")
            ]
          ]
        }
      },


      series: {

        cursor: "pointer",

        animation: {
          duration: 700
        },

        states: {

          hover: {
            lineWidthPlus: 1
          },

          inactive: {
            opacity: 1
          }
        },


        point: {

          events: {

            click: function () {

              const company =
                topCompanies[this.index];

              if (company) {
                setSelectedCompany(company);
              }
            }
          }
        },


        dataLabels: {
          enabled: false
        }
      }
    },



    series: [
      {
        name: "Crédito",

        data: topCompanies.map(
          company => Number(company.totalCredit || 0)
        ),

        color: "#114f69"
      }
    ]
  };


  // * REPORT EXCEL
  const handleDownloadExcel = () => {

    if (!selectedPatients.length) {
      return;
    }

    const excelData = selectedPatients.map(
      (patient, index) => ({
        "#": index + 1,
        "NIM": patient?.nim || "",
        "Sucursal": patient?.branchs || "",
        "Paciente": patient?.name_patient || "",
        "Monto": patient?.amount || 0
      })
    );

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Pacientes");
    XLSX.writeFile(workbook, `${selectedCompany?.nameCompany || "Clientes"}_credito.xlsx`);

  };


  // * CONFIGURATION BODY
  const companyBody = (rowData) => {

    return (
      <div className="report-banking-company-cell">

        <div className="report-banking-company-avatar">
          {rowData?.nameCompany?.charAt(0)?.toUpperCase() || "E"}
        </div>

        <div className="report-banking-company-info">

          <span className="report-banking-company-name">
            {rowData?.nameCompany}
          </span>

          <span className="report-banking-company-subtitle">
            {rowData?.totalPatients || 0} solicitudes
          </span>

        </div>

      </div>
    );
  };


  const amountBody = (rowData) => {

    return (
      <span className="report-banking-amount">
        {formatter?.format(rowData?.totalCredit || 0)}
      </span>
    );
  };


  const patientCountBody = (rowData) => {

    return (
      <span className="report-banking-count-badge">
        {rowData?.totalPatients || 0}
      </span>
    );
  };


  const actionCompanyBody = (rowData) => {

    return (
      <button
        type="button"
        className="report-banking-view-button"
        onClick={() => setSelectedCompany(rowData)}
        title="Ver detalle"
      >
        <i className="fa fa-eye" />
      </button>
    );
  };



  const nimBody = (rowData) => {

    return (
      <span
        className="report-banking-nim"
        onClick={() =>
          navigateNim(rowData?.id_work_order)
        }
      >
        {rowData?.nim}
      </span>
    );
  };


  const patientAmountBody = (rowData) => {
    return (
      <span className="report-banking-amount">
        {formatter?.format(rowData?.amount || 0)}
      </span>
    );
  };


  return (
    <div className="report-banking-container">
      <Card className="report-banking-header">
        <CardBody>
          <div className="report-banking-header-content">

            <div className="report-banking-header-left">
              <div className="report-banking-header-icon">
                <img alt="credit" src={require("../../assets/images/laboratory-External/Non-conforming.svg")} />
              </div>

              <div>
                <h4> Clientes con crédito  </h4>
                <div className="report-banking-period">
                  <i className="fa fa-building-o" />
                  <span>
                    Resumen de crédito por empresas
                  </span>
                </div>
              </div>

            </div>

            {handleClosedView && (
              <button
                type="button"
                className="report-banking-close"
                onClick={handleClosedView}
              >
                <i className="fa fa-times" />
              </button>
            )}

          </div>

        </CardBody>

      </Card>



      <Row className="report-banking-summary-row">
        <Col xl="3" md="6">
          <div className="report-banking-stat-card mb-0 pb-0">
            <div className="report-banking-stat-content">
              <div>
                <span className="report-banking-stat-title"> Empresas con crédito</span>
                <h3> {totalCompanies}  </h3>

                <small>
                  Empresas
                </small>
              </div>

              <div className="report-banking-stat-icon">
                <i className="fa fa-building" />
              </div>

            </div>



          </div>

        </Col>


        <Col xl="3" md="6">

          <div className="report-banking-stat-card">
            <div className="report-banking-stat-content">
              <div>
                <span className="report-banking-stat-title">Solicitudes </span>
                <h3>{totalPatients}</h3>

                <small>Créditos vigentes</small>

              </div>

              <div className="report-banking-stat-icon">
                <i className="fa fa-users" />
              </div>

            </div>



          </div>

        </Col>


        <Col xl="3" md="6">
          <div className="report-banking-stat-card">
            <div className="report-banking-stat-content">
              <div>
                <span className="report-banking-stat-title"> Crédito total     </span>
                <h3 className="report-banking-money"> {formatter?.format(totalCredit)}</h3>

                <small>
                  Saldo acumulado
                </small>

              </div>

              <div className="report-banking-stat-icon">
                <i className="fa fa-money" />
              </div>

            </div>



          </div>

        </Col>


        <Col xl="3" md="6">

          <div className="report-banking-stat-card report-banking-stat-highlight">
            <div className="report-banking-stat-content">
              <div>
                <span className="report-banking-stat-title">
                  Mayor crédito
                </span>

                <h3 className="report-banking-money">
                  {formatter?.format(companyHighestCredit?.totalCredit || 0)}
                </h3>

                <small>
                  {companyHighestCredit?.nameCompany || "Sin información"}
                </small>

              </div>

              <div className="report-banking-stat-icon">
                <i className="fa fa-line-chart" />
              </div>

            </div>

          </div>

        </Col>

      </Row>


      <Row>


        <Col xl="5" lg="12">
          <div className="report-banking-panel">
            <div className="report-banking-panel-header">
              <div>
                <h5>
                  <i className="fa fa-bar-chart" />
                  Empresas con mayor crédito
                </h5>

                <span className="pb-2" >
                  Top de saldos vigentes
                </span>



              </div>

            </div>

            <br />
            <div className="report-banking-chart">

              {topCompanies.length > 0 ? (
                <HighchartsReact
                  highcharts={Highcharts}
                  options={optionsCompanyChart}
                />

              ) : (

                <div className="report-banking-empty">
                  Sin información para mostrar
                </div>

              )}

            </div>

          </div>

        </Col>



        <Col xl="7" lg="12">
          <div className="report-banking-panel">
            <div className="report-banking-panel-header report-banking-table-header">
              <div>

                <h5><i className="fa fa-building-o" /> Empresas</h5>

                <span>
                  Detalle de crédito por cliente
                </span>


              </div>


              <div className="report-banking-search">
                <i className="fa fa-search" />
                <input
                  type="text"
                  placeholder="Buscar empresa..."
                  value={globalFilter}
                  onChange={(e) =>
                    setGlobalFilter(e.target.value)
                  }
                />
              </div>

            </div>


            <DataTable
              value={companyData}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 20, 50]}
              globalFilter={globalFilter}
              globalFilterFields={["nameCompany"]}
              selectionMode="single"
              selection={selectedCompany}
              onSelectionChange={(e) => setSelectedCompany(e.value)}
              dataKey="id_company"
              stripedRows
              emptyMessage="No se encontraron empresas."
              className="report-banking-datatable"
              paginatorTemplate="CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
              currentPageReportTemplate="{first} - {last} de {totalRecords}"
            >

              <Column
                header="#"
                body={(_, options) => options.rowIndex + 1}
                style={{ width: "55px", textAlign: "center" }}
              />

              <Column
                field="nameCompany"
                header="Empresa"
                body={companyBody}
                sortable
              />

              <Column
                field="totalPatients"
                header="Solicitudes"
                body={patientCountBody}
                sortable
                style={{ width: "120px", textAlign: "center" }}
              />

              <Column
                field="totalCredit"
                header="Crédito"
                body={amountBody}
                sortable
                style={{ width: "145px", textAlign: "right" }}
              />

              <Column
                body={actionCompanyBody}
                style={{ width: "65px", textAlign: "center" }}
              />

            </DataTable>

          </div>

        </Col>

      </Row>

      {selectedCompany && (
        <div className="report-banking-panel report-banking-detail-panel">
          <div className="report-banking-panel-header report-banking-detail-header">
            <div>
              <h5>
                <i className="fa fa-users" />
                {selectedCompany?.nameCompany}
              </h5>
              <span>
                Solicitudes asociadas a la empresa
              </span>

            </div>


            <div className="report-banking-detail-actions">
              <div className="report-banking-selected-total">

                <small>
                  Crédito total
                </small>

                <strong>
                  {formatter?.format(selectedCompanyTotal)}
                </strong>
              </div>


              <button
                type="button"
                className="report-banking-excel-button"
                onClick={handleDownloadExcel}
              >
                <i className="fa fa-file-excel-o" />Excel
              </button>

            </div>

          </div>

          <DataTable
            value={selectedPatients}
            paginator
            rows={10}
            rowsPerPageOptions={[10, 20, 30, 50, 100]}
            stripedRows
            responsiveLayout="scroll"
            emptyMessage="No se encontraron solicitudes."
            className="report-banking-datatable"
            paginatorTemplate="CurrentPageReport PrevPageLink PageLinks NextPageLink RowsPerPageDropdown"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
          >

            <Column
              header="#"
              body={(_, options) => options.rowIndex + 1}
              style={{
                width: "60px",
                textAlign: "center"
              }}
            />

            <Column
              field="nim"
              header="NIM"
              body={nimBody}
              sortable
            />

            <Column
              field="branchs"
              header="Sucursal"
              sortable
            />

            <Column
              field="name_patient"
              header="Paciente"
              sortable
            />

            <Column
              field="amount"
              header="Monto"
              body={patientAmountBody}
              sortable
              style={{
                width: "160px",
                textAlign: "right"
              }}
            />

          </DataTable>

        </div>

      )}

    </div>
  );
};

